/**
 * The fly-out's own layout of a plan. The API hands over a flat list of
 * questions with their `question_key`; which heading a question belongs under is
 * a frontend decision, so the order and the grouping live here rather than in
 * the template's `section` column.
 *
 * A question whose key is not listed lands in a trailing, untitled group — a
 * v1/v2 plan is written against another template and still has to render.
 */
export const ACTIONPLAN_SECTIONS = [
  {
    key: "attentionPoints",
    questionKeys: ["choices"],
  },
  {
    key: "reflection",
    questionKeys: [
      "class_rating",
      "homework_rating",
      "learn_rating",
      "motivation_rating",
    ],
  },
  {
    key: "action",
    questionKeys: ["how", "period", "need"],
  },
] as const;

/** The section a vakoverstijgend plan is never asked. */
export const ACTIONPLAN_SECTION_REFLECTION = "reflection";

/** The group everything the layout does not name falls into. */
export const ACTIONPLAN_SECTION_OTHER = "other";

/**
 * The questions the fly-out writes its own copy for, keyed by `question_key`
 * (see `pages.actionplan.questions` in the locale). `true` means the copy names
 * the subject the plan is about — "… bij Wiskunde?" — which a vakoverstijgend
 * plan drops, since there is no subject to name.
 *
 * A question that is not listed keeps the template's own wording.
 */
export const ACTIONPLAN_QUESTION_NAMES_SUBJECT: Record<string, boolean> = {
  choices: true,
  class_rating: true,
  homework_rating: true,
  learn_rating: true,
  motivation_rating: true,
  went_well: false,
  went_less: false,
};

/**
 * The three questions of "Mijn actie". Their copy is shared with the student
 * form (`pages.actionplan.questions`), attention points and all, so the fly-out
 * asks them in the same words the student answered — minus the form's
 * "(niet verplicht)" marker, which is about filling it in.
 */
export const ACTIONPLAN_ACTION_QUESTION_KEYS: string[] = [
  "how",
  "period",
  "need",
];
